import { render, staticRenderFns } from "./min-card.vue?vue&type=template&id=2898b448&scoped=true&"
import script from "./min-card.vue?vue&type=script&lang=ts&"
export * from "./min-card.vue?vue&type=script&lang=ts&"
import style0 from "./min-card.vue?vue&type=style&index=0&id=2898b448&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898b448",
  null
  
)

export default component.exports